// extracted by mini-css-extract-plugin
export var description = "style-module--description--37dc0";
export var explore = "style-module--explore--0e79a";
export var item = "style-module--item--fed37";
export var section = "style-module--section--06aab Box-module--box--d60cf";
export var sectionDescription = "style-module--sectionDescription--f6b7d";
export var sectionTitle = "style-module--sectionTitle--39b95";
export var subtitle = "style-module--subtitle--11af2";
export var threeColumns = "style-module--threeColumns--4684f";
export var title = "style-module--title--f0539";